import FormControlLabel from '@material-ui/core/FormControlLabel';
import Paper from '@material-ui/core/Paper';
import Switch from '@material-ui/core/Switch';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Typography from '@material-ui/core/Typography';
import { Button, IconButton } from "@material-ui/core";
import ArrowUpwardIcon from "@material-ui/icons/ArrowUpward";
import ArrowDownwardIcon from "@material-ui/icons/ArrowDownward";
import {
  KeyboardArrowLeft, KeyboardArrowRight,
} from '@material-ui/icons';
import classNames from 'classnames';
import {
  observer,
} from 'mobx-react';
import React, {
  Component,
} from 'react';
import Spinner from '../../Spinner';
import {
  IButtonCell, IImageCell, IOrderButtonsCell, IRenderedCell, ITextCell, IToggleButtonCell, TableCellTypes,
} from '../TableCellTypes/TableCellTypes';
import classes from './GeneralTableComponent.module.scss';
import { RequestStatus } from 'mobx-store';

interface IProps {
  title?: string;
  emptyMessage: string;
  tableData: any[];
  tableHeader: { title: string } [];
  tableCellTypes: TableCellTypes[];
  addButton?: {
    title: string;
    disabled?: boolean;
    onAdd(): void;
  };
  loading?: boolean;
  hadPagination?: boolean;
  paginationAction?: {
    pageNumber: number;
    totalNumberOfPages: number;
    handleClickLeftArrow(): void;
    handleClickRightArrow(): void;
  };
  loadingStatus?: RequestStatus[];
  sort?: (fn: 'up' | 'down', row: any) => void;
}

@observer
class GeneralTableComponent extends Component<IProps> {
  constructor(props: IProps) {
    super(props);
    // if (props.addButton!.disabled === undefined) {
    //   props.addButton!.disabled = false;
    // }
    this.state = {
      checkedA: true,
      checkedB: true,
    };
  }

  handleChange = (name: any) => (
    event: React.ChangeEvent<HTMLInputElement>,
  ) => {
    this.setState({
      [name]: event.target.checked,
    });
  };

  getTextCell = (rowIndex: number, value: string, cell: ITextCell, cellIndex: number) => (
    <TableCell key={cellIndex}>{value}</TableCell>
  );

  getToggleButtonCell = (rowIndex: number, value: boolean, cell: IToggleButtonCell, cellIndex: number) => (
    <TableCell key={cellIndex}>
      <FormControlLabel
        control={(
          <Switch
            checked={value}
            onChange={(event: any) => cell.onChange(rowIndex, cell.key, event.target.checked)}
            color="primary"
          />
          )}
        label={value ? cell.activeLabel : cell.inactiveLabel}
      />
    </TableCell>
  );

  getButtonCell = (rowIndex: number, value: string, cell: IButtonCell, cellIndex: number) => (
    <TableCell key={cellIndex}>
      <Button
        variant="contained"
        color="primary"
        onClick={() => cell.onClick(rowIndex, cell.key)}
        type="button"
        disabled={cell.disabled !== null && cell.disabled !== undefined ? cell.disabled(rowIndex) : false}
      >
        {value}
      </Button>
    </TableCell>
  );

  getImageCell = (rowIndex: number, value: string, cell: IImageCell, cellIndex: number) => {
    console.warn(value);
    return (
      <TableCell key={cellIndex}>
        <img src={value} className={classes.image} />
      </TableCell>
    );
  };

  getOrderButtonsCell = (rowIndex: number, cell: IOrderButtonsCell, cellIndex: number, tableLength: number) => (
    <TableCell key={cellIndex}>
      <Button
        variant="contained"
        className={classes.upButton}
        disabled={rowIndex === 0}
        color="primary"
        onClick={() => cell.onUpButtonClick(rowIndex, cell.key)}
        type="button"
      >
        {cell.upButtonText}
      </Button>
      <Button
        variant="contained"
        disabled={rowIndex + 1 === tableLength}
        color="primary"
        onClick={() => cell.onDownButtonClick(rowIndex, cell.key)}
        type="button"
      >
        {cell.downButtonText}
      </Button>
    </TableCell>
  );

  getRenderedCell = (cell: IRenderedCell, value: any, cellIndex: number) => (
    <TableCell key={cellIndex}>
      {cell.render(value)}
    </TableCell>
  );

  getRowElements = (row: any, rowIndex: number, tableLength: number): any => {
    const elements: any[] = [];
    for (let i = 0; i < this.props.tableCellTypes.length; i++) {
      if (this.props.tableCellTypes[i].cellType === 'ToggleButton') {
        elements.push(
          this.getToggleButtonCell(rowIndex, row[this.props.tableCellTypes[i].key], this.props.tableCellTypes[i] as IToggleButtonCell, i),
        );
      } else if (this.props.tableCellTypes[i].cellType === 'Text') {
        elements.push(
          this.getTextCell(rowIndex, row[this.props.tableCellTypes[i].key], this.props.tableCellTypes[i] as ITextCell, i),
        );
      } else if (this.props.tableCellTypes[i].cellType === 'Button') {
        elements.push(
          this.getButtonCell(rowIndex, row[this.props.tableCellTypes[i].key], this.props.tableCellTypes[i] as IButtonCell, i),
        );
      } else if (this.props.tableCellTypes[i].cellType === 'Image') {
        elements.push(
          this.getImageCell(rowIndex, row[this.props.tableCellTypes[i].key], this.props.tableCellTypes[i] as IImageCell, i),
        );
      } else if (this.props.tableCellTypes[i].cellType === 'OrderButtons') {
        elements.push(
          this.getOrderButtonsCell(rowIndex, this.props.tableCellTypes[i] as IOrderButtonsCell, i, tableLength),
        );
      } else if (this.props.tableCellTypes[i].cellType === 'render') {
        elements.push(
          this.getRenderedCell(this.props.tableCellTypes[i] as IRenderedCell, row, i),
        );
      }
    }
    return elements;
  };

  renderTable = () => {

    let addButton = null;

    if (this.props.addButton) {
      addButton = (
        <Button
          variant="contained"
          color="primary"
          className={classes.addButton}
          onClick={() => this.props.addButton!.onAdd()}
          type="button"
          disabled={!!this.props.addButton.disabled}
        >
          {this.props.addButton.title}
        </Button>
      );
    }

    const tableDataLength = this.props.tableData.length;

    return (
      <div className={classes.tableContainer}>
        <Typography variant="h6" gutterBottom className={classNames(classes.content)}>
          {this.props.title ? this.props.title : null}
        </Typography>

        <div className={classes.actions}>
          {addButton}
        </div>
        <Paper className={classes.root}>
          <Table className={classes.table}>
            <TableHead>

              <TableRow className={classes.tableHead}>
                {this.props.sort && (<TableCell className={classes.cell}>Sort</TableCell>)}


                {
                  this.props.tableHeader.map((ele, index) => (
                    <TableCell key={index} className={classes.cell}>{ele.title}</TableCell>
                  ))
                }
              </TableRow>
            </TableHead>
            <TableBody>
              {
                this.props.tableData.map((row, rowIndex) => (

                  <TableRow key={rowIndex}>
                    {!!this.props.sort && (
                      <TableCell className={classes.cell}>
                        <div style={{ display: "flex", gap: 8 }}>
                          <IconButton
                            size="small"
                            onClick={() => this.props.sort && this.props.sort('up', row)}
                          >
                            <ArrowUpwardIcon />
                          </IconButton>

                          <IconButton
                            size="small"
                            onClick={() => this.props.sort && this.props.sort('down', row)}
                          >
                            <ArrowDownwardIcon />
                          </IconButton>
                        </div>
                      </TableCell>
                    )}


                    {
                      this.getRowElements(row, rowIndex, tableDataLength)
                    }
                  </TableRow>
                ))
              }
            </TableBody>
          </Table>
          {
            this.props.hadPagination
              ? (
                <div className={classes.paginationContainer}>
                  <p className={classes.paginationText}>
                    {`page ${this.props.paginationAction!.pageNumber} of ${this.props.paginationAction!.totalNumberOfPages} pages`}
                  </p>
                  <button
                    className={classes.arrowButton}
                    onClick={() => this.props.paginationAction!.handleClickLeftArrow()}
                    disabled={this.props.paginationAction!.pageNumber === 1}
                  >
                    <KeyboardArrowLeft />
                  </button>
                  <button
                    className={classes.arrowButton}
                    disabled={this.props.paginationAction!.pageNumber === this.props.paginationAction!.totalNumberOfPages}
                    onClick={() => this.props.paginationAction!.handleClickRightArrow()}
                  >
                    <KeyboardArrowRight />
                  </button>
                </div>
              )
              : null
          }
        </Paper>
      </div>
    );
  }

  renderEmptyMesage = () => {
    let addButton = null;

    if (this.props.addButton) {
      addButton = (
        <Button
          variant="contained"
          color="primary"
          className={classes.addButton}
          onClick={() => this.props.addButton!.onAdd()}
          type="button"
          disabled={!!this.props.addButton.disabled}
        >
          {this.props.addButton.title}
        </Button>
      );
    }
    return (
      <div className={classes.emptyContainer}>
        <div className={classes.card}>
          <Typography variant="subtitle1" gutterBottom className={classNames(classes.content)}>
            {this.props.emptyMessage}
          </Typography>
          <div className={classes.actions}>
            {addButton}
          </div>
        </div>
      </div>
    );
  }

  calculateLoadingStatus = (requests: RequestStatus[]) => {
    for (const request of requests) {
      if (request !== RequestStatus.SUCCESS) {
        return true;
      }
    }
    return false;
  }

  render() {
    if (this.props.loading || (this.props.loadingStatus && this.calculateLoadingStatus(this.props.loadingStatus))) {
      return <Spinner />;
    }

    if (!this.props.tableData.length) {
      return this.renderEmptyMesage();
    } else {
      return this.renderTable();
    }

  }
}

export default GeneralTableComponent;
